var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgIconLanguageHindi = function SvgIconLanguageHindi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    x: 1,
    y: 1,
    fill: "#FFF",
    stroke: "#EC1D39",
    strokeWidth: 2,
    rx: 13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB1E3B",
    d: "M52.36 60.066l-4.026 7.458c-12.012-1.188-22.374-5.94-22.374-15.972 0-3.3 1.65-6.336 4.488-8.58-3.696-2.178-5.28-5.082-5.28-8.448 0-4.554 3.762-7.656 9.9-7.656h7.986v-3.96H20.02v-7.194h39.27v7.194h-7.26v11.154H37.312c-2.442 0-3.168.924-3.168 2.244 0 1.254.924 2.64 2.838 3.564 1.848-.528 3.894-.792 6.138-.792 7.458 0 11.418 4.95 11.418 10.23 0 3.696-1.716 6.468-3.432 8.514L43.582 53.4c1.518-1.518 2.838-3.036 2.838-4.884 0-1.452-1.32-2.31-3.3-2.31-5.016 0-8.184 2.376-8.184 5.676 0 3.762 3.234 7.062 17.424 8.184z"
  }))));
};
export default SvgIconLanguageHindi;